<template>
  <div
    class="hold-transition login-bg theme-default"

  >
    <div class="login-logo-mobile d-block d-sm-none">
      <img :src="getImage('logo.svg')" alt="Carnival Internet" />
    </div>
    <div class="login-container">
      <div class="login-img">
        <img :src="getImage('login-bg.png')" alt="Carnival Internet" />
        <!-- <div class="login-img-overlay">
          <h3>
            CONNECTING YOU TO<br />
            A FASTER WORLD
          </h3>
          <p>{{ new Date().getFullYear() }} © Dotlines. All rights reserved.</p>
        </div> -->
      </div>

      <!-- /.login-logo -->
      <div class="login-box-body">
        <div class="login-logo d-none d-sm-block">
          <a
          href="javascript:void(0);"
          >
            <span class="logo-lg">
              <img :src="getImage('logo.svg')" alt="Carnival Internet" />
            </span>
          </a>
        </div>
        <h2>Welcome to our Selfcare portal!</h2>

        <div class="overlay text-center" v-if="is_loading">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <form
          @submit.prevent="login()"
          method="POST"
          class="response-alert"
          novalidate
        >
          <div class="form-group mb-3">
            <label class="control-label">Email</label>
            <input
              type="email"
              name="email"
              v-model.trim="user.email"
              class="form-control"
              placeholder="Email"
              v-validate="'required'"
              :class="{ 'has-error': errors.has('email') }"
            />
            <div class="help text-danger" v-show="errors.has('email')">
              {{ errors.first("email") }}
            </div>
            <p v-if="errorMsg.email" class="text-danger text-sm font-italic ">{{ errorMsg.email }}</p>
          </div>

          <div class="form-group mb-3">
            <label class="control-label">Password</label>
            <input
              type="password"
              name="password"
              v-model.trim="user.password"
              class="form-control"
              placeholder="Password"
              v-validate="'required'"
              :class="{ 'has-error': errors.has('password') }"
            />
            <div class="help text-danger" v-show="errors.has('password')">
              {{ errors.first("password") }}
            </div>
            <p v-if="errorMsg.password" class="text-danger text-sm font-italic ">{{ errorMsg.password}}</p>
          </div>
          <div class="form-group">
            <router-link class="forgot-pass" :to="{ name: 'ForgotPass' }">
              Forgot password ?
            </router-link>
          </div>
          <div class="row mb-3 align-items-center">
            <div class="col-6">
            <div class="icheck-primary">
              <input
                type="checkbox"
                v-model.trim="user.remember"
                id="remember"
              />
              <label for="remember"> Remember Me </label>
            </div>
          </div>
            <!-- /.col -->
          </div>
          <button
            type="submit"
            class="btn btn-common btn-block btn-login"
            :disabled="is_disabled"
          >
            Login
          </button>
          <router-link to="/admin/dashboard" custom v-slot="{ href, navigate }">
            <a ref="loginTo" :href="href"></a>
          </router-link>
        </form>
      </div>
      <!-- /.login-box-body -->
    </div>
    <!-- e -->
  </div>
</template>
<style scoped>
.login-page {
  margin-top: -60px;
}
.close{
  padding-top: 0px !important;
}
</style>

<script>
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";
import axios from "axios";
import { forEach } from "lodash";

export default {
  metaInfo: {
    title: "Login | Carnival Internet Login",
  },
  components: {
    //
  },
  data: () => ({
    user: {},
    errorMsg : {
      email: '',
      password: '',
    },

    is_loading: false,
    is_disabled: false,

  }),
  methods: {
    Navigate(navigate, event) {
      navigate(event);
    },


    encrypt(text){
    const key = process.env.VUE_APP_AES_KEY;
    const iv = process.env.VUE_APP_AES_IV;
    const cryptoRef = this.$CryptoJS;
    let encrypted = cryptoRef.AES.encrypt(text, key, { iv: iv });
    encrypted = encrypted.toString();
    return encrypted;
    },

    decrypt(encryptedText){
    const key = process.env.VUE_APP_AES_KEY;
    const iv = process.env.VUE_APP_AES_IV;
    const cryptoRef = this.$CryptoJS;
    let decryptedText = cryptoRef.AES.decrypt(encryptedText, key, { iv: iv});
    decryptedText = decryptedText.toString(cryptoRef.enc.Utf8);
     //console.log("Decrypted Text::::", decryptedText);
     return decryptedText;
    },
    clearErrors() {
      this.errorMsg = {
        email: '',
        password: '',
      };
    },


    login: function (e) {

      // let password = this.decrypt(this.encrypt(this.user.password));
      // console.log("Password:::", password);

      // console.log("__USER__", this.user);
      // return;
      this.clearErrors();

      let anchorTag = this.$refs.loginTo;
      this.$validator.validateAll().then((result) => {
        if (result) {
          // let api_url = this.API_BASE_URL + "/auth/login";
          let api_url = this.API_BASE_URL + "/auth/panelLogin";
          let token = "";
          let _this = this;
          this.is_loading = true;
          this.is_disabled = true;
          axios({
            method: "post",
            url: api_url,
            data: _this.user,
          })
            .then(function (response) {
              if (response.status === 200) {
                token = response.data.token;
                localStorage.setItem("authenticate", true);
                localStorage.setItem("token", token);
                if(_this.user.remember){
                  localStorage.setItem("remember_me", _this.user.remember);
                  localStorage.setItem("email", _this.encrypt(_this.user.email));
                  localStorage.setItem("password", _this.encrypt(_this.user.password));
                  //console.log("User:::", _this.user);
                }else{
                  localStorage.removeItem("remember_me");
                  localStorage.removeItem("email");
                  localStorage.removeItem("password");
                }
                //window.location = "/";
                anchorTag.click();
                // _this.$router.push({ path: "/admin/dashboard", replace: true }); // for mobile app
                // _this.$router.go({ name: "dashboard" }); // for mobile app
              } else {
                this.errorMsg = response.data;
                console.log("From else", response.data);
                $(".response-alert").prepend(
                  $(
                    '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                      "    Invalid username or password!\n" +
                      '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                      '       <span aria-hidden="true">&times;</span>\n' +
                      "    </button>\n" +
                      "</div>"
                  )
                );

              }
            })
            .catch(function (error) {
              console.log("In Error Block:::::", error.response);
              if (error.response) {


                // Request made and server responded
                /*console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);*/
              if(error.response.status === 429 ){
                  // Too many request for an users
                  const msg = error.response.data.message;
                  $(".response-alert").prepend(
                      $(
                      '<div class="alert alert-danger alert-dismissible fade show" role="alert">' +
                        msg +
                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'+
                            '<span aria-hidden="true">&times;</span>'+
                        '</button>'
                        +
                        "</div>"
                      )
                  );
              }else{
                console.log(error.response.data.errors)

                _this.errorMsg.email = error.response.data?.errors?.email || '';
                _this.errorMsg.password = error.response.data?.errors?.password || '';

                // $(".response-alert").prepend(
                //   $(
                //     '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                //       (_this.errorMsg.email? _this.errorMsg.email: _this.errorMsg.password) +
                //       // "    Invalid username or password!\n" +
                //       '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                //       '       <span aria-hidden="true">&times;</span>\n' +
                //       "    </button>\n" +
                //       "</div>"
                //   )
                // );
              }

              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
              }
            })
            .finally(function () {
              _this.is_loading = false;
              _this.is_disabled = false;
              setTimeout(() => {
                $(".alert").fadeOut("slow");
              }, 5000);
            });

          console.warn(this.user);
          /*this.axios.post(baseUrl + 'login', this.user)
            .then((response) => {
              var data = response.data.data;
              localStorage.setItem('token', data.token);
              this.$router.push('/');
            })
            .catch((error) => {
              //
            });*/
        }
      });
    },
  },
  mounted: function () {
    let _this = this;
    localStorage.setItem("authenticate", false);
    localStorage.removeItem("token");

    let remember_me = localStorage.getItem("remember_me");
    remember_me = JSON.parse(remember_me);
    console.log("Remember Me:::", remember_me);
    if(remember_me != null && remember_me == true){
      let email = localStorage.getItem("email");
      let password = localStorage.getItem("password");
      if(email){
        email= this.decrypt(email);
      }
      if(password){
        password = this.decrypt(password);
      }
      _this.user.email = email;
      _this.user.password = password;
      _this.user.remember = remember_me;
    }else{
      console.log("Not remember me block");
    }
  },
  created() {
    this.$emit("update:layout", GuestLayout);
  },
};
</script>
